export default __webpack_public_path__ + "assets/hoogste_korting.575c5e15.svg";